export default __webpack_public_path__ + "static/google-play-7a15c16133c0101510ef2de7badf38c4.png";